import { useCallback, useRef, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import dialogs from '../../dialogs';
import Icon from '../../components/Icon';
import BaseModal from '../../dialogs/BaseModal';
import { Title } from '../../utils/title';
import Layout from './Layout';
import styles from './Creator.module.scss';
import { useParams } from 'react-router';

import hero from './common/hero.module.scss';
import section_a from './common/section_a.module.scss';
import section_b from './common/section_b.module.scss';
import action_a from './common/action_a.module.scss';
import action_b from './common/action_b.module.scss';
import cards from './common/cards.module.scss';
import videos_styles from './common/videos.module.scss';
import video_modal from './common/video_modal.module.scss';

import hero_4 from '../../assets/landing/hero/4.gif';


import section_1_lg from '../../assets/landing/section/creator/1_lg.png';
import section_1_sm from '../../assets/landing/section/creator/1_sm.png';
import section_1_svg from '../../assets/landing/section/creator/1_svg.svg';

import section_2_lg from '../../assets/landing/section/creator/2_lg.png';
import section_2_sm from '../../assets/landing/section/creator/2_sm.png';
import section_2_svg from '../../assets/landing/section/creator/2_svg.svg';

import section_3_lg from '../../assets/landing/section/creator/3_lg.png';
import section_3_sm from '../../assets/landing/section/creator/3_sm.png';
import section_3_svg from '../../assets/landing/section/creator/3_svg.svg';

import action_b_creator from '../../assets/landing/action/b_creator.svg';

import icon_compass from '../../assets/landing/icons/compass.svg';
import icon_plus from '../../assets/landing/icons/plus.svg';
import icon_share from '../../assets/landing/icons/share.svg';

const CDN = 'https://d11ohw7lid905l.cloudfront.net/videos/landing';

const VIDEOS = [
  { url: `${CDN}/landing_video_1.mp4`, thumbnail: `${CDN}/landing_tmb_1.png` },
  { url: `${CDN}/landing_video_2.mp4`, thumbnail: `${CDN}/landing_tmb_2.png` },
  { url: `${CDN}/landing_video_3.mov`, thumbnail: `${CDN}/landing_tmb_3.png` },
  { url: `${CDN}/landing_video_4.mp4`, thumbnail: `${CDN}/landing_tmb_4.png` },
  { url: `${CDN}/landing_video_5.mp4`, thumbnail: `${CDN}/landing_tmb_5.png` },
  { url: `${CDN}/landing_video_6.mp4`, thumbnail: `${CDN}/landing_tmb_6.png` },
  { url: `${CDN}/landing_video_7.mov`, thumbnail: `${CDN}/landing_tmb_7.png` },
  { url: `${CDN}/landing_video_8.mov`, thumbnail: `${CDN}/landing_tmb_8.png` },
  { url: `${CDN}/landing_video_9.mov`, thumbnail: `${CDN}/landing_tmb_9.png` },
  { url: `${CDN}/landing_video_10.MOV`, thumbnail: `${CDN}/landing_tmb_10.png` },
  { url: `${CDN}/landing_video_11.mp4`, thumbnail: `${CDN}/landing_tmb_11.png` },
];

const Hero = () => {

  const { locale } = useParams();
  const { setDialog } = dialogs.utils.useDialog();


  const translations = {
    en: {
      t1: 'Try free products',
      t2: 'Share your opinions',
      t3: 'Earn rewards',
      h1: 'Join the Chimeable community to discover and test the latest products from top brands, completely free. Post honest reviews and short videos on TikTok, Instagram, and YouTube, and get rewarded for your content!',
      s1: 'Sign Up',
      d1: 'Discover free products today...',
    },
    'ca-fr': {
      t1: 'Essayez des produits gratuits',
      t2: 'Partagez vos avis',
      t3: 'Gagnez des récompenses',
      h1: 'Rejoignez la communauté Chimeable pour découvrir et tester gratuitement les produits les plus récents des plus grandes marques. Publiez des avis honnêtes et de courtes vidéos sur TikTok, Instagram et YouTube, et recevez des récompenses pour votre contenu!',
      s1: 'Inscrivez-vous',
      d1: 'Découvrez de nouveaux produits incroyables...',
    },
  };

  // Get current language (default to 'en')
  const lang = locale && translations[locale] ? locale : 'en';
  const page_content = translations[lang];
  const isFrench = lang === 'ca-fr';


  return (
    <div className={hero.root}>
      <div className={hero.content}>
        <div className={`${hero.title_tiktok} ${isFrench ? hero.title_tiktok_fr : ''}`}>
          {page_content.t1}
          <br />
          {page_content.t2}
          <br />
          {page_content.t3}
        </div>


        <div className={hero.image_3}>
          <LazyLoadImage
            src={hero_4}
            alt='video review'
          />
        </div>

        <div className={hero.text_tiktok}>
          {page_content.h1}
        </div>

        <div className={hero.action}>
          <button onClick={() => setDialog('signup')}>
            {page_content.s1}
          </button>
        </div>
      </div>
    </div>
  );
};

const Videos = () => {

  const [activeVideo, setActiveVideo] = useState(null);
  const listRef = useRef(null);

  const scroll = useCallback((direction) => {
    const list = listRef.current;
    if (!list) return;
    const item = list.querySelector('[data-item]');
    if (!item) return;
    const distance = item.offsetWidth + 20;
    list.scrollBy({ left: direction * distance, behavior: 'smooth' });
  }, []);

  return (
    <div className={videos_styles.root}>
      <div className={videos_styles.content}>
        <div className={videos_styles.title}>
          Member Stories
        </div>

        <div className={videos_styles.slider}>
          <button
            className={videos_styles.arrow}
            onClick={() => scroll(-1)}
            aria-label='previous'
          >
            <Icon name='chevron_left' />
          </button>

          <div className={videos_styles.list} ref={listRef}>
            {VIDEOS.map((video, index) => (
              <div
                key={index}
                data-item
                className={videos_styles.item}
                onClick={() => setActiveVideo(video)}
              >
                <LazyLoadImage
                  src={video.thumbnail}
                  alt='member story'
                />
                <div className={videos_styles.overlay}>
                  <Icon name='play_circle' />
                </div>
              </div>
            ))}
          </div>

          <button
            className={videos_styles.arrow}
            onClick={() => scroll(1)}
            aria-label='next'
          >
            <Icon name='chevron_right' />
          </button>
        </div>
      </div>

      {activeVideo && (
        <BaseModal
          onClose={() => setActiveVideo(null)}
        >
          <video
            src={activeVideo.url}
            autoPlay
            controls
            playsInline
            className={video_modal.player}
          />
        </BaseModal>
      )}
    </div>
  );
};

const SectionA1 = () => {

  const { locale } = useParams();


  const translations = {
    en: {
      d1: 'Discover free products today...',
      t1: 'Join the Chimeable community to access the world’s best brands. Free and discounted items are delivered directly to your door so you can test and fall in love with brands one by one!',
    },
    'ca-fr': {
      d1: 'Découvrez de nouveaux produits incroyables...',
      t1: 'Rejoignez notre communauté de créateurs pour accéder aux meilleures marques du monde. Des articles gratuits et à prix réduit vous sont livrés directement à votre porte afin que vous puissiez tester et tomber en amour avec les marques une à la fois!',
    },
  };

  // Get current language (default to 'en')
  const lang = locale && translations[locale] ? locale : 'en';
  const page_content = translations[lang];
  const isFrench = lang === 'ca-fr';

  return (
    <div className={section_a.root}>
      <div className={section_a.content}>
        <div className={section_a.image}>
          <LazyLoadImage
            className={section_a.lg}
            src={section_1_lg}
            alt='cosmetics'
          />
          <LazyLoadImage
            className={section_a.sm}
            src={section_1_sm}
            alt='cosmetics'
          />
        </div>

        <div className={section_a.svg}>
          <LazyLoadImage
            src={section_1_svg}
            alt='discover'
          />
        </div>

        <div className={section_a.title + (isFrench ? ` ${section_a.title_fr}` : '')}>
          {page_content.d1}
        </div>

        <div className={section_a.text}>
          {page_content.t1}
        </div>
      </div>
    </div>
  );
};

const SectionB = () => {

  const { locale } = useParams();

  const translations = {
    en: {
      d1: 'Share your opinion...',
      t1: 'After testing a product, simply write a review via our platform or the brand\'s website. Chime in with your thoughts, spread the word and help other consumers just like you to discover brands they will love.',
    },
    'ca-fr': {
      d1: 'Partagez votre avis...',
      t1: 'Après avoir testé un produit, il vous suffit de rédiger un avis via notre plateforme ou le site web de la marque. Faites part de vos impressions, faites passer le mot et aidez d\'autres consommateurs comme vous à découvrir des marques qu\'ils adoreront.',
    },
  };

  // Get current language (default to 'en')
  const lang = locale && translations[locale] ? locale : 'en';
  const page_content = translations[lang];


  return (
    <div className={section_b.root}>
      <div className={section_b.content}>
        <div className={section_b.image}>
          <LazyLoadImage
            className={section_b.lg}
            src={section_2_lg}
            alt='man using a mobile device'
          />
          <LazyLoadImage
            className={section_b.sm}
            src={section_2_sm}
            alt='man using a mobile device'
          />
        </div>

        <div className={section_b.svg}>
          <LazyLoadImage
            src={section_2_svg}
            alt='share'
          />
        </div>

        <div className={section_b.title}>
          {page_content.d1}
        </div>

        <div className={section_b.text}>
          {page_content.t1}
        </div>
      </div>
    </div>
  );
};

const SectionA2 = () => {

  const { locale } = useParams();

  const translations = {
    en: {
      d1: 'Stand out and be heard',
      t1: 'This is where the magic happens! Written reviews are automagically converted to engaging video content ready to share with the world via popular social media networks like TikTok, Instagram, Twitter and Facebook. View, edit, customise and share.',
    },
    'ca-fr': {
      d1: 'Démarquez-vous et faites-vous entendre',
      t1: 'C\'est là que la magie opère! Les avis écrits sont automatiquement convertis en contenu vidéo attrayant, prêt à être partagé avec le monde entier via les réseaux sociaux populaires tels que TikTok, Instagram, Twitter et Facebook. Visualisez, modifiez, personnalisez et partagez',
    },
  };

  // Get current language (default to 'en')
  const lang = locale && translations[locale] ? locale : 'en';
  const page_content = translations[lang];
  const isFrench = lang === 'ca-fr';


  return (
    <div className={section_a.root}>
      <div className={section_a.content}>
        <div className={section_a.image}>
          <LazyLoadImage
            className={section_a.lg}
            src={section_3_lg}
            alt='woman using a mobile device'
          />
          <LazyLoadImage
            className={section_a.sm}
            src={section_3_sm}
            alt='woman using a mobile device'
          />
        </div>

        <div className={section_a.svg}>
          <LazyLoadImage
            src={section_3_svg}
            alt='network'
          />
        </div>

        <div className={section_a.title + (isFrench ? ` ${section_a.title_fr}` : '')}>
          {page_content.d1}
        </div>

        <div className={section_a.text}>
          {page_content.t1}
        </div>
      </div>
    </div>
  );
};

const ActionA = () => {

  const { locale } = useParams();

  const translations = {
    en: {
      d1: 'Reviews worth sharing',
      t1: 'Discover new products, share your opinions and let your voice be heard!',
      s1: 'Sign Up',
    },
    'ca-fr': {
      d1: 'Des avis qui méritent d\'être partagés',
      t1: 'Découvrez de nouveaux produits, partagez vos opinions et faites entendre votre voix!',
      s1: 'Inscrivez-vous',
    },
  };

  // Get current language (default to 'en')
  const lang = locale && translations[locale] ? locale : 'en';
  const page_content = translations[lang];


  const { setDialog } = dialogs.utils.useDialog();

  return (
    <div className={action_a.root}>
      <div className={action_a.content}>
        <div className={action_a.title}>
          {page_content.d1}
        </div>

        <div className={action_a.text}>
          {page_content.t1}
        </div>

        <div className={action_a.action}>
          <button onClick={() => setDialog('signup')}>
            {page_content.s1}
          </button>
        </div>
      </div>
    </div>
  );
};

const ActionB = () => {

  const { setDialog } = dialogs.utils.useDialog();
  const { locale } = useParams();

  const translations = {
    en: {
      d1: 'Discover free products today..',
      s1: 'Let\'s Go!',
    },
    'ca-fr': {
      d1: 'Découvrez des produits gratuits dès aujourd\'hui...',
      s1: 'C\'est parti!',
    },
  };

  // Get current language (default to 'en')
  const lang = locale && translations[locale] ? locale : 'en';
  const page_content = translations[lang];


  return (
    <div className={action_b.root}>
      <div className={action_b.content}>
        <div className={action_b.title}>
          {page_content.d1}
        </div>

        <div className={action_b.action}>
          <button onClick={() => setDialog('signup')}>
            {page_content.s1}
          </button>
        </div>

        <div className={action_b.image}>
          <LazyLoadImage
            src={action_b_creator}
            alt='discover'
          />
        </div>
      </div>
    </div>
  );
};

const Cards = () => {

  const { locale } = useParams();
  const translations = {
    en: {
      d1: 'Why Chimeable?',
      d2: 'Discover New Products',
      d3: 'Create a Following',
      d4: 'Help Fellow Consumers',
      t2: 'Get free and discounted items delivered to your door.',
      t3: 'Share your opinions and find fame with your reviews.',
      t4: 'Share your reviews and help consumers to discover new brands.',
    },
    'ca-fr': {
      d1: 'Pourquoi Chimeable?',
      d2: 'Découvrez de nouveaux produits',
      d3: 'Créez une communauté',
      d4: 'Aidez les autres consommateurs',
      t2: 'Recevez des articles gratuits et à prix réduit directement chez-vous.',
      t3: 'Partagez vos opinions et devenez célèbre grâce à vos avis.',
      t4: 'Partagez vos avis et aidez les consommateurs à découvrir de nouvelles marques.',
    },
  };
  const lang = locale && translations[locale] ? locale : 'en';
  const page_content = translations[lang];

  return (
    <div className={cards.root}>
      <div className={cards.title}>
        {page_content.d1}
      </div>

      <div className={`${cards.content} ${cards.col_3}`}>
        <div className={cards.card}>
          <div className={cards.image}>
            <LazyLoadImage
              src={icon_compass}
              alt='compass'
            />
          </div>

          <div className={cards.title}>
            {page_content.d2}
          </div>

          <div className={cards.text}>
            {page_content.t2}
          </div>
        </div>

        <div className={cards.card}>
          <div className={cards.image}>
            <LazyLoadImage
              src={icon_plus}
              alt='plus'
            />
          </div>

          <div className={cards.title}>
            {page_content.d3}
          </div>

          <div className={cards.text}>
            {page_content.t3}
          </div>
        </div>

        <div className={cards.card}>
          <div className={cards.image}>
            <LazyLoadImage
              src={icon_share}
              alt='share'
            />
          </div>

          <div className={cards.title}>
            {page_content.d4}
          </div>

          <div className={cards.text}>
            {page_content.t4}
          </div>
        </div>
      </div>
    </div>
  );
};

const Creator = () => {
  return (
    <>
      <Title value='Creators' />
      <Layout>
        <div className={styles.root}>
          <Hero />
          <Videos />
          <SectionA1 />
          <SectionB />
          <SectionA2 />
          <ActionA />
          <Cards />
          <ActionB />
        </div>
      </Layout>
    </>
  );
};

export default Creator;